import { InjectionToken } from '@angular/core';
/**
 * input components may receive additional form control information from formControlNameStandalone.
 * To do so, the component must provide itself as FORM_CONTROL_NAME_HOST.
 * The directive will then look for any of the listed below functions and call them when existing.
 */
export const FORM_CONTROL_NAME_HOST = /*#__PURE__*/new InjectionToken('form-control-name-host');